import {TimelineMax, TweenMax} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');


    const tajMahalImg = Shortcuts.getSprite('tajMahal', TextureCache, 'tajMahalImg');
    const tajMahal = new PIXI.Container();
    tajMahalImg.anchor.x = 0.5;
    tajMahal.position.x = sizes.coverWidth / 2;
    tajMahal.addChild(tajMahalImg);

    const eyesImg = Shortcuts.getSprite('eyes', TextureCache, 'eyesImg');
    const eyes = new PIXI.Container();
    eyesImg.anchor.x = 0.5;
    eyesImg.anchor.y = 0.23;
    eyes.position.x = sizes.coverWidth / 2;
    eyes.addChild(eyesImg);

    const overshadows = Shortcuts.getSprite('overshadows', TextureCache);
    const redMap = Shortcuts.getSprite('redMap', TextureCache);

    const blueMapImg = Shortcuts.getSprite('blueMap', TextureCache, 'blueMapImg');
    const blueMap = new PIXI.Container();
    blueMapImg.anchor.x = 1;
    blueMap.position.x = sizes.coverWidth;
    blueMap.addChild(blueMapImg);

    eyes.z = -0.1;
    blueMap.z = 1;
    redMap.z = 1.2;
    tajMahal.z = -0.2;

    cont.addChild(tajMahal);
    cont.addChild(blueMap);
    cont.addChild(redMap);
    cont.addChild(eyes);
    cont.addChild(overshadows);

    cont.scale.x = cont.scale.y = sizes.width / sizes.coverWidth;

    instance.cont = cont;
    instance.width = sizes.coverWidth;
    instance.height = sizes.coverHeight;
    instance.eyesImg = eyesImg;
    instance.eyes = eyes;
    instance.redMap = redMap;
    instance.blueMapImg = blueMapImg;
    instance.blueMap = blueMap;
    instance.tajMahalImg = tajMahalImg;
    instance.tajMahal = tajMahal;
    instance.overshadows = overshadows;
    instance.parallaxLayers = [eyes, blueMap, redMap, tajMahal];
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true, onUpdate: () => {
        // console.log('update', instance.cont.alpha, instance.cont.parent)
    }});
    const d1 = 4.5;
    const d2 = 4.5;

    // SET
    TweenMax.set(instance.overshadows, {alpha: 1});
    TweenMax.set([instance.tajMahal, instance.eyes, instance.blueMap, instance.redMap], {alpha: 0});
    TweenMax.set(instance.eyes, {z: -0.1});
    TweenMax.set(instance.blueMap, {z: 1});
    TweenMax.set(instance.redMap, {z: 1.2});
    TweenMax.set(instance.tajMahal, {z: -0.2});
    TweenMax.set(instance.tajMahal.scale, {x: 0.98, y: 0.98});
    TweenMax.set(instance.eyes.scale, {x: 1.03, y: 1.03});
    TweenMax.set(instance.blueMap.position, {x: 1.05 * instance.width, y: -0.02 * instance.height});
    TweenMax.set(instance.redMap.position, {x: -0.05 * instance.width, y: -0.02 * instance.height});


    tl.set(instance.overshadows, {alpha: 1});
    tl.set([instance.tajMahal, instance.eyes, instance.blueMap, instance.redMap], {alpha: 0});
    tl.set(instance.eyes, {z: -0.1});
    tl.set(instance.blueMap, {z: 1});
    tl.set(instance.redMap, {z: 1.2});
    tl.set(instance.tajMahal, {z: -0.2});
    tl.set(instance.tajMahal.scale, {x: 0.98, y: 0.98});
    tl.set(instance.eyes.scale, {x: 1.03, y: 1.03});
    tl.set(instance.blueMap.position, {x: 1.05 * instance.width, y: -0.02 * instance.height});
    tl.set(instance.redMap.position, {x: -0.05 * instance.width, y: -0.02 * instance.height});

    // IN
    tl.to([instance.tajMahal, instance.eyes, instance.blueMap, instance.redMap], d1 * 0.4, {alpha: 1}, 'start');
    tl.to(instance.tajMahal.scale, d1 * 0.4, {x: 1, y: 1}, 'start');
    tl.to(instance.eyes.scale, d1 * 0.7, {x: 1, y: 1}, 'start');
    tl.to(instance.blueMap.position, d1, {x: 1 * instance.width, y: 0}, 'start');
    tl.to(instance.redMap.position, d1, {x: 0, y: 0}, 'start');

    // OUT
    tl.to([instance.tajMahal, instance.eyes, instance.blueMap, instance.redMap], 0.1, {alpha: 1}, 'out');
    tl.to(instance.tajMahal.scale, d2, {x: 0.8, y: 0.8}, 'out');
    tl.to(instance.eyes.scale, d2, {x: 0.95, y: 0.95}, 'out');
    tl.to(instance.blueMap.scale, d2, {x: 0.92, y: 0.92}, 'out');
    tl.to(instance.redMap.scale, d2, {x: 0.92, y: 0.92}, 'out');
    tl.to(instance.tajMahal.position, d2, {y: -0.4 * instance.height}, 'out');
    tl.to(instance.eyes.position, d2, {y: -0.35 * instance.height}, 'out');
    tl.to(instance.blueMap.position, d2, {x: 1 * instance.width, y: -0.5 * instance.height}, 'out');
    tl.to(instance.redMap.position, d2, {x: 0, y: -0.5 * instance.height}, 'out');

    tl.to([instance.tajMahal, instance.eyes, instance.blueMap, instance.redMap, instance.overshadows], d2 * 0.1, {alpha: 0}, 'out+=' + d2 * 0.9);

    instance.timeline = tl;
    return tl;
}


function CoverTimelineConstructor(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 4.5;
    constructor.totalDuration = 9;

    return constructor;
}


module.exports = CoverTimelineConstructor;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/CoverTimelineConstructor.js